import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'Components/ThematicIcon/ThematicIcon';

import css from './IconWrapper.scss';

const IconWrapper = ({ className, onClick, dataAutId, id, ...rest }) => (
    <span
        className={ classNames(css.iconWrapper, className) }
        onClick={ onClick }
        onKeyDown={ onClick }
        role="listbox"
        tabIndex="0"
        aria-label="Icon"
        id={ id }
        data-aut-id={ dataAutId }>
        <Icon { ...rest } />
    </span>
);

IconWrapper.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    dataAutId: PropTypes.string,
    id: PropTypes.string
};

IconWrapper.defaultProps = {
    className: '',
    onClick: () => {},
    dataAutId: '',
    id: ''
};

export default IconWrapper;
